export const formatDateToUSA = (date) => {
    const [year, month, day] = date.split('-');
    return `${month}/${day}/${year}`;
  };